import { Anchor, Card } from '@zenid/web';
import { css } from '../../../../styled-system/css';
import { flex } from '../../../../styled-system/patterns';

/**
 * 既にサブメールアドレスが登録済みのアカウントで統合の導線に入った場合の案内。
 * 失敗ではなく既に完了している状態のため、完了画面 (IntegrationComplete) と同じ体裁とする。
 */
export function IntegrationAlreadyRegistered() {
  return (
    <Card
      className={css({
        width: '343px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.20}',
        sm: { width: '400px', padding: '{spacing.40}' },
      })}
    >
      <div
        className={flex({
          flexDirection: 'column',
          justifyContent: 'center',
        })}
      >
        <div className={flex({ justifyContent: 'center', paddingBottom: '{spacing.24}' })}>
          <img
            width="88px"
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/change_success.png`}
            alt="サブメールアドレス登録済み"
          />
        </div>
        <div
          className={flex({
            flexDirection: 'column',
            gap: '{spacing.16}',
          })}
        >
          <h1
            className={css({
              textStyle: 'headding.l',
              textAlign: 'center',
              color: '{colors.text.main}',
              wordBreak: 'keep-all',
            })}
          >
            このアカウントには既にサブメールアドレスが登録されています
          </h1>
          <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}', textAlign: 'center' })}>
            別のアカウントで操作する場合はログアウトしてください。
          </p>
        </div>
      </div>
      <Anchor
        variant="button"
        href="/logout"
        className={css({ marginTop: '{spacing.24}' })}
        color="primary"
        size="l"
        stretch="container"
      >
        ログアウト
      </Anchor>
    </Card>
  );
}
